
        import { makeFungusComponent } from '@/vue/decorators/angular-interop';
        export default function (Component) {
            const template = "\n<vrm-dropdown id=\"{{dropdownTrigger}}\" close-on=\"mouseleave\">\n    <div class=\"vrm-dropdown__item\" ng-repeat=\"item in items\" ng-click=\"item.action()\">\n        <span ng-class=\"item.icon_class\"></span>\n        <a>{{item.text}}</a>\n    </div>\n</vrm-dropdown>\n";
            const query = {"vue":"","type":"custom","index":"0","blockType":"angular-template","tag":"div"};
            makeFungusComponent(Component, template, query);
        }
    